var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 10.8497C3.83774 10.4614 3 9.36422 3 8.07136C3 6.83002 3.78259 5.72352 4.95303 5.30999L11.0006 3.17331C11.6473 2.94483 12.3527 2.94483 12.9994 3.17331L19.047 5.30999C20.2174 5.72352 21 6.83002 21 8.07136C21 9.36422 20.1623 10.4614 19 10.8497V15.1707C20.1652 15.5826 21 16.6938 21 18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18C3 16.6938 3.83481 15.5826 5 15.1707V10.8497ZM5.9258 9.00002H18.0742C18.5858 8.99848 19 8.58329 19 8.07136C19 7.67774 18.7518 7.32688 18.3807 7.19575L12.3331 5.05907C12.1176 4.98291 11.8824 4.98291 11.6669 5.05907L5.61929 7.19575C5.24815 7.32688 5 7.67774 5 8.07136C5 8.58329 5.41423 8.99848 5.9258 9.00002ZM7 11V15H9V11H7ZM11 11V15H13V11H11ZM15 11V15H17V11H15ZM18 17C18.5523 17 19 17.4477 19 18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18C5 17.4477 5.44772 17 6 17H18Z",
    fill: "#3EAA69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.a0e8a96574f09337f087cf24f59f1a43.svg";
export { ForwardRef as ReactComponent };